import PropTypes from "prop-types";
import { useState } from "react";
import Modal from "../modal/Modal";
import { MODAL_TYPE } from "../../constants";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import ReviewPolicy from "../reviewPolicy/ReviewPolicy";
import useEventBus from "../../hooks/useEventBus";
import { REVIEW_POLICY_OPEN_MODAL_EVENT } from "./constants";

export default function ReviewPolicyContainer() {
  const { getTranslation, webContext } = useRuntimeConstants();
  const modalId = "reviewPolicyModal";
  const [open, setOpen] = useState(false);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [focusOnCloseElement, setFocusOnCloseElement] = useState(null);

  useEventBus(
    REVIEW_POLICY_OPEN_MODAL_EVENT,
    ({ focusOnCloseElement }) => {
      setOpen(true);
      setContentLoaded(true);
      setFocusOnCloseElement(focusOnCloseElement);
    },
    []
  );

  return (
    <Modal
      title={getTranslation("pdp_ratings_reviews_more_information_title")}
      open={open}
      closeModal={() => setOpen(false)}
      focusOnClose={focusOnCloseElement}
      modalId={modalId}
      modalType={MODAL_TYPE.SIDE}
      contentLoaded={contentLoaded}
      withDarkThemeSupport={true}
    >
      <ReviewPolicy browseLanguage={webContext.browseLanguage} />
    </Modal>
  );
}

ReviewPolicyContainer.propTypes = {
  open: PropTypes.bool.isRequired,
  closeReviewPolicyModal: PropTypes.func.isRequired,
  reviewPolicyModalFocusOnClose: PropTypes.func,
};
